// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"fbf2160e","17":"bb09d42a","254":"739b195f","390":"6db47d83","483":"efe315ec","845":"f47ec353","998":"18adb628"}[chunkId] + ".chunk.js";
};